import { URL_STATE } from '../List/constants'

import { LAST_24_HOURS } from './constants'

/**
 * dateFilter for both GET /incidents/count/ and POST /irontraps/incidents.
 *
 * Legacy Challenged has no time-frame UI — always Last 24 hours (3).
 * Redesign (including Challenged) and every other tab: selected dateFilter,
 * else favorite → company default.
 */
export const resolveIncidentRequestDateFilter = ({
  urlState,
  incidentsRedesignEnabled,
  dateFilter,
  effectiveDateFilter,
}) => {
  if (urlState === URL_STATE.CHALLENGED && !incidentsRedesignEnabled) {
    return LAST_24_HOURS
  }
  return dateFilter || effectiveDateFilter
}
